import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import {
  AstSignMailHandoffStatus,
  type AstSignMailState,
} from 'features/ast-signmail/interfaces';
import type { TransferAstRelayResponse } from 'features/call/call-base/interfaces';

export const initialAstSignMailState: AstSignMailState = {
  handoffStatus: AstSignMailHandoffStatus.INACTIVE,
  astSignMailMode: undefined,
  transferAstRelayResponse: null,
};

export const astSignMailSlice = createSlice({
  name: 'astSignMail',
  initialState: initialAstSignMailState,
  reducers: {
    claimAstSignMailHandoff: (state) => {
      state.handoffStatus = AstSignMailHandoffStatus.TRANSFERRING;
    },
    startAstSignMailHandoff: (state) => {
      state.handoffStatus = AstSignMailHandoffStatus.SHOWING;
    },
    endAstSignMailHandoff: (state) => {
      state.handoffStatus = AstSignMailHandoffStatus.INACTIVE;
      state.transferAstRelayResponse = null;
    },
    astSignMailModeReceived: (
      state,
      action: PayloadAction<number | undefined>
    ) => {
      state.astSignMailMode = action.payload;
    },
    transferAstRelayResponseReceived: (
      state,
      action: PayloadAction<TransferAstRelayResponse>
    ) => {
      state.transferAstRelayResponse = action.payload;
    },
  },
});

export const {
  claimAstSignMailHandoff,
  startAstSignMailHandoff,
  endAstSignMailHandoff,
  astSignMailModeReceived,
  transferAstRelayResponseReceived,
} = astSignMailSlice.actions;

export const astSignMailReducer = astSignMailSlice.reducer;
